import React from 'react';
import './Header.css';

const Header = () => {
    const scrollToSection = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    };

  return (
    <header className="header">
      <div className="logo">
        <a href="#home">
          <img src="/logo.png" alt="Logo" />
        </a>
      </div>
      <nav className="nav-buttons">
        <a href="#home" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a>
        <a href="#background" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('background'); }}>Background</a>
        <a href="#projects" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('projects'); }}>Projects</a>
        <a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a>
      </nav>
    </header>
  );
};

export default Header;